import React from 'react'
import '../App.css'
import Bodybilletera from './bodybilletera'
export class Bodyappbilleterabody extends React.Component {
    state = {
    }
    render() {       
        return (
            <div className="flex flex-row space-x-4"> {/* flex-row organiza los elementos horizontalmente */}
                <Bodybilletera/>
            </div>
        
        );
    }
}